import { LTUtils } from "../../../LTGame/LTUtils/LTUtils";
import { P2Manager } from "../../../LTGame/Physics/P2Manager";
import LayerDefine from "../../common/LayerDefine";
import ItemBase from "./ItemBase";
export default class ItemPet extends ItemBase {
    OnInit() {
        this.group = LayerDefine.Item;
        this.mask = LayerDefine.Player;
        this.CreateModel();
        this.CreateBody();
    }
    CreateBody() {
        let body = LTUtils.GetComponentsInChildren(this.rootObj, Laya.PhysicsCollider)[0];
        this.bodyOwner = body.owner;
        this.body = P2Manager.instance.CreateBody(this.bodyOwner, this.group, this.mask, p2.Body.STATIC);
        P2Manager.instance.AddBody(this.body);
        this.body["use"] = this;
    }
    SyncPos() {
        P2Manager.instance.SyncTransToRigXZ(this.bodyOwner.transform, this.body);
    }
    OnUpdate(dt) {
        this.SyncPos();
    }
}
